import { cn } from '@/utils/cn';

interface IconSecureZoneSize {
  xs: string;
  sm: string;
  md: string;
  lg: string;
}

interface IconSize {
  xs: string;
  sm: string;
  md: string;
  lg: string;
}

interface IconProps {
  className?: string;
  iconClassName?: string;
  iconName: string;
  variant?: 'outline' | 'solid';
  // Allow only the sizes defined in ButtonSize
  size?: keyof IconSize;
}

const iconSecureZoneSize: IconSecureZoneSize = {
  xs: cn('w-4 h-4'),
  sm: cn('w-4 h-4'),
  md: cn('w-6 h-6'),
  lg: cn('w-9 h-9'),
};

const iconSize: IconSize = {
  xs: cn('w-3 h-3 text-base'),
  sm: cn('w-4 h-4 text-base'),
  md: cn('w-6 h-6 text-lg'),
  lg: cn('w-8 h-8 text-2xl'),
};

export default function Icon({
  className,
  iconName,
  iconClassName,
  variant = 'solid',
  size = 'md',
}: IconProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center p-1 flex-shrink-0',
        iconSecureZoneSize[size],
        className
      )}
    >
      <span
        className={cn(
          'flex items-center justify-center flex-shrink-0',
          iconClassName,
          iconSize[size],
          {
            'font-icons-solid leading-none': variant === 'solid',
            'font-icons-outlined leading-none': variant === 'outline',
          }
        )}
      >
        {iconName}
      </span>
    </span>
  );
}
